export const interests = [
  {
    label: 'All',
    code: 'ALL',
    category: 1,
    checked: false,
  },
];
